import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/layout/Default.js";
import NavigationLogin from './components/navigationLogin';
import NavigationAvatar from './components/navigationAvatar';
import NavigationSearch from './components/navigationSearch';
import NavigationMenu from './components/navigationMenu';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h2>{`Usage`}</h2>
    <p>{`Navigation bar is a menu that contains structured links and functions to direct the user to another page from the page that is being displayed.`}</p>
    <p>{`use of components don’t forget to add import `}<inlineCode parentName="p">{`legion-ui`}</inlineCode></p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { Navbar, NavbarBrand, NavbarCollapse, NavbarContent, NavbarItem, NavbarToggle } from 'legion-ui';
`}</code></pre>
    <div className="divi" />
    <h2>{`Variant`}</h2>
    <p>{`Legion Have 4 variant of Navigation Bar:`}</p>
    <h3><strong parentName="h3">{`Basic Navigation Bar`}</strong></h3>
    <p>{`you can add `}<inlineCode parentName="p">{`Button`}</inlineCode>{` component in navigation or other components`}</p>
    <div style={{
      "padding": "2rem",
      "backgroundColor": "#F6F7FC"
    }}>
  <NavigationLogin mdxType="NavigationLogin" />
    </div>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`const NavigationLogin = () => {
  const [activeToggle, setActiveToggle] = useState(false);

  return (
    <Navbar variant="sticky" mode="light">
      <NavbarBrand style={{ display: 'flex', alignItem: 'center' }}>
        <Heading size="h3" color="primary500">
          Legion
        </Heading>
        <NavbarContent>
          <Flex>
            <Button variant="transparent" css={{ marginRight: '.5rem' }}>
              Daftar
            </Button>
            <Button variant="solid">Masuk</Button>
          </Flex>
        </NavbarContent>
        <NavbarToggle onClick={() => setActiveToggle(!activeToggle)} />
      </NavbarBrand>
      <NavbarCollapse isActive={activeToggle}>
        <Box>
          <NavbarItem href="/home">Menu 1</NavbarItem>
        </Box>
        <Box>
          <NavbarItem>Menu 1</NavbarItem>
        </Box>
        <Box>
          <NavbarItem>Menu 1</NavbarItem>
        </Box>
        <Box>
          <NavbarItem>Menu 1</NavbarItem>
        </Box>
      </NavbarCollapse>
    </Navbar>
  );
};
`}</code></pre>
    <div className="divi" />
    <h3><strong parentName="h3">{`Navigation with Menu`}</strong></h3>
    <p>{`this navigation bar with added `}<inlineCode parentName="p">{`menu`}</inlineCode></p>
    <div style={{
      "padding": "2rem",
      "backgroundColor": "#F6F7FC"
    }}>
  <NavigationMenu mdxType="NavigationMenu" />
    </div>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`const NavigationMenu = () => {
  const [activeToggle, setActiveToggle] = useState(false);

  return (
    <Navbar variant="sticky" mode="light">
      <NavbarBrand style={{ display: 'flex', alignItem: 'center' }}>
        <Heading size="h3" color="primary500">
          Legion
        </Heading>
        <NavbarContent>
          <NavbarItem href="/home">Menu 1</NavbarItem>
          <NavbarItem isActive href="/profile">
            Menu 1
          </NavbarItem>
          <NavbarItem>Menu 1</NavbarItem>
          <NavbarItem>Menu 1</NavbarItem>
        </NavbarContent>
        <NavbarToggle onClick={() => setActiveToggle(!activeToggle)} />
      </NavbarBrand>
      <NavbarCollapse isActive={activeToggle}>
        <Box>
          <NavbarItem href="/home">Menu 1</NavbarItem>
        </Box>
        <Box>
          <NavbarItem>Menu 1</NavbarItem>
        </Box>
        <Box>
          <NavbarItem>Menu 1</NavbarItem>
        </Box>
        <Box>
          <NavbarItem>Menu 1</NavbarItem>
        </Box>
      </NavbarCollapse>
    </Navbar>
  );
};
`}</code></pre>
    <div className="divi" />
    <h3><strong parentName="h3">{`Navigation with Search`}</strong></h3>
    <p>{`this navigation bar added `}<inlineCode parentName="p">{`search`}</inlineCode>{`component`}</p>
    <div style={{
      "padding": "2rem",
      "backgroundColor": "#F6F7FC"
    }}>
  <NavigationSearch mdxType="NavigationSearch" />
    </div>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`const NavigationSearch = () => {
  const [activeToggle, setActiveToggle] = useState(false);

  return (
    <Navbar variant="sticky" mode="light">
      <NavbarBrand style={{ display: 'flex', alignItem: 'center' }}>
        <Heading size="h3" color="primary500">
          Legion
        </Heading>
        <NavbarContent>
          <div className="boxtextfield" style={{ width: 250 }}>
            <Textfield iconLeft={<DynamicIcon name="Search" />} placeholder="Search" style={{ margin: 0 }} />
          </div>
        </NavbarContent>
        <NavbarToggle onClick={() => setActiveToggle(!activeToggle)} />
      </NavbarBrand>
      <NavbarCollapse isActive={activeToggle}>
        <Box>
          <NavbarItem href="/home">Menu 1</NavbarItem>
        </Box>
        <Box>
          <NavbarItem>Menu 1</NavbarItem>
        </Box>
        <Box>
          <NavbarItem>Menu 1</NavbarItem>
        </Box>
        <Box>
          <NavbarItem>Menu 1</NavbarItem>
        </Box>
      </NavbarCollapse>
    </Navbar>
  );
};
`}</code></pre>
    <div className="divi" />
    <h3><strong parentName="h3">{`Navigation with Avatar`}</strong></h3>
    <p>{`this navigation bar added `}<inlineCode parentName="p">{`icon`}</inlineCode>{`, `}<inlineCode parentName="p">{`search`}</inlineCode>{` and `}<inlineCode parentName="p">{`avatar`}</inlineCode></p>
    <div style={{
      "padding": "2rem",
      "backgroundColor": "#F6F7FC"
    }}>
  <NavigationAvatar mdxType="NavigationAvatar" />
    </div>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`const NavigationAvatar = () => {
  const [activeToggle, setActiveToggle] = useState(false);

  return (
    <Navbar variant="sticky" mode="light">
      <NavbarBrand style={{ display: 'flex', alignItem: 'center' }}>
        <Heading size="h3" color="primary500">
          Legion
        </Heading>
        <NavbarContent>
          <div style={{ width: 300 }}>
            <Select
              options={[
                { value: 'chocolate', label: 'Chocolate' },
                { value: 'strawberry', label: 'Strawberry' },
                { value: 'vanilla', label: 'Vanilla' },
              ]}
              iconLeft={<DynamicIcon name="Search" />}
            />
          </div>
        </NavbarContent>
        <NavbarContent>
          <NavbarItem isActive>
            <DynamicIcon name="Home" color="white" />
          </NavbarItem>
          <NavbarItem>
            <DynamicIcon name="MessageSquare" />
          </NavbarItem>
          <NavbarItem>
            <DynamicIcon name="Grid" />
          </NavbarItem>
          <NavbarItem>
            <Avatar size="medium" src="https://xsgames.co/randomusers/assets/avatars/male/76.jpg" />
          </NavbarItem>
        </NavbarContent>
        <NavbarToggle onClick={() => setActiveToggle(!activeToggle)} />
      </NavbarBrand>
      <NavbarCollapse isActive={activeToggle}>
        <Box>
          <NavbarItem href="/home">Menu 1</NavbarItem>
        </Box>
        <Box>
          <NavbarItem>Menu 1</NavbarItem>
        </Box>
        <Box>
          <NavbarItem>Menu 1</NavbarItem>
        </Box>
        <Box>
          <NavbarItem>Menu 1</NavbarItem>
        </Box>
      </NavbarCollapse>
    </Navbar>
  );
};
`}</code></pre>
    <div className="divi" />
    <h2>{`Props`}</h2>
    <h3><strong parentName="h3">{`Navbar`}</strong></h3>
    <p>{`Main Navbar, the very outer wrapper`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`property`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`propType`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`required`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`children`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`React.ReactNode`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Pass all the necessary components here`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`isBordered`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Makes the navbar have border around it (only avail in floating variant)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`isCompact`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Makes the navbar have no vertical (top and bottom) gap`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`mode`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`light`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`dark`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`light`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets the navbar background mode`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`variant`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`static`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`floating`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`sticky`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`static`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets the navbar position`}</td>
        </tr>
      </tbody>
    </table>
    <h3><strong parentName="h3">{`NavbarBrand`}</strong></h3>
    <p>{`Wraps the left side of the Navbar, wrap your logo inside here`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`property`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`propType`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`required`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`children`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`React.ReactNode`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Pass all the necessary components here`}</td>
        </tr>
      </tbody>
    </table>
    <h3><strong parentName="h3">{`NavbarCollapse`}</strong></h3>
    <p>{`Wrapper to hold the mobile/tablet navigation of your App, you can ignore this if you don’t need responsive menu`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`property`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`propType`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`required`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`children`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`React.ReactNode`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Pass all the necessary components here`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`isActive`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Will show when isActive value is true, trigger it with React’s state in your App`}</td>
        </tr>
      </tbody>
    </table>
    <h3><strong parentName="h3">{`NavbarContent`}</strong></h3>
    <p>{`Wraps usually the mid and right side of the Navbar, wrap your contents such as menu, buttons, search inputs, avatar, around here.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`property`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`propType`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`required`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`children`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`React.ReactNode`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Pass all the necessary components here`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`hideIn`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`sm`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`md`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`lg`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`xl`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`md`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Make sure to hide the contents when it reached the given hideIn value`}</td>
        </tr>
      </tbody>
    </table>
    <h3><strong parentName="h3">{`NavbarItem`}</strong></h3>
    <p>{`List of childs of your menu after being wrapped inside NavbarContent`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`property`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`propType`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`required`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`children`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`React.ReactNode`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Pass all the necessary components here`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`href`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Routing address you desire to fill in`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`isActive`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Will get highlighted if value is true, useful usually combined with routing to indicate in which route are we`}</td>
        </tr>
      </tbody>
    </table>
    <h3><strong parentName="h3">{`NavbarToggle`}</strong></h3>
    <p>{`A menu button to click, to trigger the NavbarCollapse activation.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`property`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`propType`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`required`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`onClick`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`React.MouseEventHandler`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`onClick trigger, make it a setState function to change the boolean value to trigger NavbarCollapse’s show/hide`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`showIn`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`sm`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`md`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`lg`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`xl`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`md`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Make sure to show the toggle when it reached the given showIn value`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      